import { useCallback, useEffect, useRef } from 'react';

const useDebouncedCommit = (commitFn, wait = 800) => {
  const timerRef = useRef(null);
  const pendingRef = useRef(null);

  const cancel = useCallback(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const flush = useCallback((reason) => {
    if (!pendingRef.current) return;
    cancel();
    const payload = pendingRef.current;
    pendingRef.current = null;
    commitFn(payload.elements, reason || payload.reason);
  }, [cancel, commitFn]);

  const schedule = useCallback((elements, reason) => {
    pendingRef.current = { elements, reason };
    cancel();
    timerRef.current = setTimeout(() => {
      flush();
    }, wait);
  }, [cancel, flush, wait]);

  useEffect(() => () => cancel(), [cancel]);

  return {
    schedule,
    flush,
    cancel,
  };
};

export default useDebouncedCommit;
